const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/relative.ts';
import { createPatapiCall, HttpMethod } from 'App/utils/fetchUtils';
import { kisapiActionTypes } from '@cistec/common_web/defs/actionTypes';

export const REQUEST_ACTION_TYPES_LOAD_RELATIVES = kisapiActionTypes('PATAPP_LOAD_RELATIVES_RECORDS');

export function loadPatientDataForFall(fallNr: string) {
    // FIXME: Why is this cases? Should it then not be in case?
    const endpoint = `cases/${fallNr}`;
    const meta = { fallNr, suppressErrorMsg: true };
    return createPatapiCall(REQUEST_ACTION_TYPES_LOAD_RELATIVES, endpoint, HttpMethod.GET, meta);
}
